/**
 * Nguồn dữ liệu khi chọn tham số báo cáo
 * nxhinh 19.09.2024
 */
export default {
    // Số kiểm tra đơn vị cấp dưới
    Examine: 1, 
    // Tổng hợp dự toán sau lập
    Summary: 2,
    // Lần nộp
    Submit: 3,
    // Nhu cầu
    Receive: 4,
    // Kiểm tra
    Audit: 5,
    // Tổng hợp kiểm tra
    SummaryAudit: 6,
  };
